module.exports = __webpack_public_path__ + "40b728aca71dc70ab65a9fb2febfb20a.png";